module.exports = __webpack_public_path__ + "img/lishiditu.8cbe8cfa.png";